import React from "react";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import TradeCards from "./TradeCard";
import { usePendingOrders } from "../../hooks/usePendingOrders";
import OrderDetailsDialog from "../Common/OrderDetailsDialog";
import { getOrderDetailFields } from "../../utils/orderDetailsConfig";
import GenericTable from "../Common/GenericTable";
import { pendingOrdersConfig } from "../../config/tableConfigs";
import CommonMessages from '../Common/NoDataMessages';
import NoOrdersIllustration from '../Common/NoOrdersIllustration';

const Pending = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  
  const {
    pendingOrders,
    loading,
    error,
    selectedOrder,
    isPending,
    handleModifyOrder,
    handleDeleteClick,
    handleRowClick,
    handleCloseDetails,
    formatTime,
  } = usePendingOrders();

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          p: 3,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CircularProgress color="primary" />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        sx={{
          p: 3,
          textAlign: "center",
          color: theme.palette.error.main,
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Typography>{error}</Typography>
      </Box>
    );
  }

  return (
    <>
      {pendingOrders.length === 0 ? (
        <CommonMessages
          icon={<NoOrdersIllustration />}
          messageHead="No pending orders"
          messageBody="Place an order from your watchlist"
        />
      ) : isMobile ? (
        <TradeCards trades={pendingOrders} isPending={isPending} />
      ) : (
        <GenericTable
          data={pendingOrders}
          config={pendingOrdersConfig(handleModifyOrder, handleDeleteClick, isMobile)}
          onRowClick={handleRowClick}
          isMobile={isMobile}
        />
      )}

      {selectedOrder && (
        <OrderDetailsDialog
          order={selectedOrder}
          onClose={handleCloseDetails}
          isMobile={isMobile}
          detailFields={getOrderDetailFields(selectedOrder, formatTime, 'PENDING')}
          formatTime={formatTime}
        />
      )}
    </>
  );
};

export default Pending;
